import { faBackward } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import { ModalFooter } from "../components/layout/ModalProvider";

export const RevertInspectionModal: FC<{ inspection: Inspection }> = (props) => {
  const { refreshAll } = useApi();
  const { revertInspection } = useApiCall();
  const confirm = async () => {
    await revertInspection(props.inspection.id);
    await refreshAll();
  };
  return (
    <>
      <div>Je staat op het punt om de volgende inspectie terug te zetten.</div>
      <div className={"font-semibold my-2"}>
        &middot; <span>{props.inspection.name}</span>
      </div>

      <ModalFooter text={"Terugzetten"} icon={faBackward} onSubmit={confirm} />
    </>
  );
};
